module.exports = __webpack_public_path__ + "/images/ico-cover-cart-success.317d165.svg";